import * as React from 'react';

export interface HostParts {
	host: string;
	hostname: string;
	protocol: string;
	subdomain: string | null;
}

export const useHostParts = (): HostParts =>
	React.useMemo(() => {
		const { host, hostname, protocol } = window.location;
		const index = host.indexOf('.');
		const lastIndex = host.lastIndexOf('.');

		return index === lastIndex
			? {
					host,
					hostname,
					protocol,
					subdomain: null,
			  }
			: {
					host: host.slice(index + 1),
					hostname: hostname.slice(index + 1),
					protocol,
					subdomain: host.slice(0, index),
			  };
	}, []);
